import * as angular from "angular";
import {IController} from "angular";
import {DeliveriesRequestsService} from "../../../deliveries/services/deliveries-requests.service";

export class TimeSlotPickerComponent implements IController {
  timeWindow: any;
  dateTimeStamp: any;
  branchId: any;
  disabled: any;
  autoSelect: any;
  onChange: Function;

  timeSlotMap: any = {};
  dayName: any = null;
  all: any = undefined;

  readonly daysOfWeek: string[] = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Monday', 'Saturday'];

  constructor(private deliveriesRequestsService: DeliveriesRequestsService, private moment) {

  }

  $onInit() {
    this.deliveriesRequestsService.getAnalysisConfiguration(this.branchId)
      .then((response) => {
        this.timeSlotMap = response.timeSlotMap;
        if (this.dateTimeStamp) {
          this.dayName = this.daysOfWeek[this.moment(this.dateTimeStamp).day()]

          if (!this.timeWindow) {
            this.onChooseDefault();
          }
        }
      });
  }

  $onChanges(changes) {
    if (changes.dateTimeStamp && !changes.dateTimeStamp.isFirstChange()) {
      if (this.dateTimeStamp) {
        this.dayName = this.daysOfWeek[this.moment(this.dateTimeStamp).day()]
        this.onChooseDefault();
      }
    }
    if (changes.branchId && !changes.branchId.isFirstChange()) {
      this.$onInit();
    }

    if (changes.timeWindow && !changes.timeWindow.isFirstChange()) {
      this.$onInit();
    }

    if (changes.disabled && !changes.disabled.isFirstChange()) {
      if (this.disabled) {
        this.onChange({timeWindow: undefined});
      }
    }
  };


  onChooseDefault() {
    this.onChange({timeWindow: this.autoSelect ? this.timeSlotMap[this.dayName][0] : undefined});
  }

}


angular
  .module('bringoz.admin.commons')
  .component('timeSlotPicker', {
    bindings: {
      timeWindow: '<',
      dateTimeStamp: '<',
      branchId: '<?',
      disabled: '<?',
      autoSelect: '<',
      onChange: '&'
    },
    templateUrl: 'app/modules/commons/components/time-slot-picker/time-slot-picker.html',
    controller: TimeSlotPickerComponent
  });
